module.exports = __webpack_public_path__ + "img/qr-app-en.f961768.svg";